import ReactDOM from 'react-dom/client';
import 'i18n/i18n';
import App from './app/App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
      navigator.serviceWorker.register('/mindbox-services-worker.js')
          .then(registration => {
              console.log('Service Worker зарегистрирован');
          })
          .catch(error => {
              console.error('Ошибка регистрации Service Worker', error);
          });
  });
}

root.render(<App />);
